export class SessionCustomerInfo {
    id: string;
    name: string;
    email: string;
    phone: string;

    //The following is not saved on amazon. We only use it internally
    isPhoneVerified?:boolean;
    isMailVerified?:boolean;

    constructor(id: string, name: string, email: string, phone: string, mailVerified?:boolean, phoneVerified?:boolean) {
        this.id = id;
        this.name = name
        this.email = email;
        this.phone = phone;
        this.isPhoneVerified = phoneVerified ;
        this.isMailVerified = mailVerified;
    }

    /** Generates a new SessionCustomerAddress. Either returns a full object or "undefined" */
    static newFromAws(awsAddressData: any): SessionCustomerInfo | undefined {
        if (awsAddressData != null) {
            return new SessionCustomerInfo(
                awsAddressData.id,
                awsAddressData.name,
                awsAddressData.email,
                awsAddressData.phone
            );
        } else {
            return undefined;
        }
    }

    /** Converts this object into a format that can be saved on our database (DynamoDB) */
    toAwsObject() {
        const customerAddressObj:any = {
            "id": this.id,
            "name": this.name,
            "phone": this.phone
        }

        if(this.email!=null){
            customerAddressObj["email"] = this.email;
        }
        
        return customerAddressObj;
    }
}